import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { AffiliationDocument } from '../types';
import CalendarIcon from '../icons/CalendarIcon';
import QuestionMarkIcon from '../icons/QuestionMarkIcon';
interface IProps {
	post: AffiliationDocument;
}

const LocationCard = ({ post }: IProps) => {
	const permalink = `${window.findaConnector.locationBaseUrl}/${post.slug}`;

	let hasExpeditedAppointment = post.meta.expedited_appointment;
	// TODO: Remove the line below when expedited appointment feature launches also convert let above to const.
	hasExpeditedAppointment = false;

	return (
		<a href={permalink} target="_self" rel="noreferrer" className="location-card">
			<div className="location-card__content">
				<h3 className="location-card__title">
					<span dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.title) }} />
					{hasExpeditedAppointment && (
						<div className="tooltip">
							<CalendarIcon />
							<div className="tooltip-content">
								<QuestionMarkIcon />
								<p className="tooltip-title">
									{sanitizeHtml(window.expeditedAppointmentTitle)}
								</p>
								<p className="tooltip-text">
									{sanitizeHtml(window.expeditedAppointmentText)}
								</p>
							</div>
						</div>
					)}
				</h3>

				<p className="location-card__address">
					{sanitizeHtml(post.meta.address)}, {sanitizeHtml(post.meta.city)},{' '}
					{sanitizeHtml(post.meta.state)}
				</p>

				<span className="btn-tertiary">View Surgery Center</span>
			</div>
		</a>
	);
};

export default LocationCard;
